'use client';
import { useInView, useSpring, config } from '@react-spring/web';

export const useSpringCount = (value: number) => {
  const [animatedRef, isInView] = useInView({
    amount: 0.8,
  });
  // 检测value的小数位长度
  const decimalLength = value.toString().split('.')[1]?.length || 0;
  const props = useSpring({
    to: { number: isInView ? value : 0 },
    from: { number: 0 },
    config: config.slow,
  });
  return {
    animatedRef,
    count: props.number.to((t) => t.toFixed(decimalLength)),
  };
};
